import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("sisu_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.length < 300) return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "Dato no válido")).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (status >= 500)
    return "El servicio no está disponible en este momento. Inténtelo de nuevo en unos minutos.";
  return "Ha ocurrido un error. Inténtelo de nuevo.";
}

export const GROUPS = [
  { value: "infantil", label: "Infantil (Inglés)" },
  { value: "primaria_1r_cicle", label: "Primaria 1r cicle (1º, 2º y 3º)" },
  { value: "primaria_2n_cicle", label: "Primaria 2n cicle (4º, 5º y 6º)" },
  { value: "eso_1r_cicle", label: "ESO 1r cicle (1º y 2º)" },
  { value: "eso_2n_cicle", label: "ESO 2n cicle (3º y 4º)" },
  { value: "bachillerato", label: "Bachillerato (1º y 2º)" },
];

export const SLOT_GROUP_LABELS = {
  eso2n_bach: "ESO 3º-4º y Bachiller 1º-2º",
  gr: "Grupo Reducido (GR)",
};

/** Una franja es válida para una agrupación si es GR, si coincide, o si es la combinada ESO 3º-4º + Bachillerato. */
export const slotMatchesGroup = (slot, group) =>
  !group ||
  slot.stage_group === group ||
  slot.stage_group === "gr" ||
  (slot.stage_group === "eso2n_bach" && ["eso_2n_cicle", "bachillerato"].includes(group));

export const groupLabel = (v) =>
  GROUPS.find((g) => g.value === v)?.label || SLOT_GROUP_LABELS[v] || v;
export const FRANJAS = [
  ["15:30", "16:30"],
  ["16:30", "17:30"],
  ["17:30", "18:30"],
  ["18:30", "19:30"],
  ["19:30", "20:30"],
  ["20:30", "21:30"],
];
export const MAX_BIG_HOURS = 4;
export const MAX_GR_HOURS = 2;
export const DAYS = ["", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes"];
export const LOGO_TIMES = ["15:30", "16:15", "17:00", "17:45", "18:30", "19:15"];
export const SEDES = { xalo: "Xaló", denia: "Dénia" };
export const SEDE_DAYS_TEXT = { xalo: "martes y jueves", denia: "lunes y miércoles" };
export const SEDE_WEEKDAYS = { xalo: [2, 4], denia: [1, 3] };
export const ANAMNESIS_FIELDS = [
  ["motivo", "Motivo de la consulta"],
  ["antecedentes", "Antecedentes familiares o médicos relevantes"],
  ["desarrollo", "Desarrollo del lenguaje (primeras palabras, evolución)"],
  ["salud", "Datos de salud (audición, visión, dentista u ortodoncista, tratamientos)"],
  ["escolar", "Colegio, curso y apoyos: Audición y Lenguaje, adaptaciones"],
  ["otros", "Otros profesionales externos, informes y comentarios de la familia"],
];
export const BLOCK_SUBJECTS = {
  CIENCIAS: ["Matemáticas", "Física y Química", "Biología"],
  LETRAS: ["Valenciano", "Castellano", "Inglés"],
};
export const SCHEDULE_MODES = {
  fijo: "Horario fijo",
  flexible: "Horario flexible mensual",
};
export const MONTH_LABELS = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
  "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
/** "2026-09" -> "Septiembre de 2026" */
export const monthName = (m) => `${MONTH_LABELS[Number(m.slice(5, 7)) - 1]} de ${m.slice(0, 4)}`;
/** Mes siguiente al actual en formato aaaa-mm. */
export const nextMonthISO = () => {
  const d = new Date();
  const y = d.getMonth() === 11 ? d.getFullYear() + 1 : d.getFullYear();
  const m = d.getMonth() === 11 ? 1 : d.getMonth() + 2;
  return `${y}-${String(m).padStart(2, "0")}`;
};
export const thisMonthISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
/** Tramo de precios que corresponde a cada etapa educativa. */
export const TIER_OF = (group) => {
  if (group === "infantil") return "Infantil";
  if (group.startsWith("primaria")) return "Primaria";
  if (group.startsWith("eso")) return "ESO";
  return "Bachillerato";
};
/** Fecha de hoy en formato aaaa-mm-dd (hora local del navegador). */
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
/** Último día del mes de una fecha aaaa-mm-dd. */
export const monthEnd = (iso) => {
  const [y, m] = iso.split("-").map(Number);
  const last = new Date(y, m, 0);
  return `${y}-${String(m).padStart(2, "0")}-${String(last.getDate()).padStart(2, "0")}`;
};
